import { IconTrust16, Label } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { verifiedByCianSelector } from './selectors';

export function VerifiedByCianLabelContainer() {
  const isVerifiedByCian = useSelector(verifiedByCianSelector);

  if (!isVerifiedByCian) {
    return null;
  }

  return (
    <Label background="primary_10" color="primary_100" icon={<IconTrust16 color="primary_100" />}>
      Проверено Циан
    </Label>
  );
}
